import AbstractPolygon from './../AbstractPolygon';
import ChengDuCountyData from './data.json';
export default class ChengDuCountyPolygon extends AbstractPolygon {
    constructor(opts) {
        super(opts, ChengDuCountyData)
    }
}